import { GENERATION_MODES } from './constants';
import type { GenerationMode } from './types';

interface ModeSelectorProps {
  value: GenerationMode;
  onChange: (value: GenerationMode) => void;
  enabledModes?: {
    text2img: boolean;
    img2img: boolean;
    inpaint: boolean;
  };
}

export function ModeSelector({ value, onChange, enabledModes }: ModeSelectorProps) {
  // 过滤掉禁用的模式
  const availableModes = GENERATION_MODES.filter((mode) => {
    if (!enabledModes) return true;
    return enabledModes[mode.id] !== false;
  });

  return (
    <div>
      <label className="text-sm font-medium text-light-text mb-3 block">生成模式</label>
      <div className="grid grid-cols-3 gap-2">
        {availableModes.map((mode) => {
          const Icon = mode.icon;
          const isActive = value === mode.id;
          return (
            <button
              key={mode.id}
              onClick={() => onChange(mode.id)}
              data-active={isActive}
              className={`flex flex-col items-center gap-2 p-3 rounded-xl border transition-all ${
                isActive
                  ? 'border-accent-blue bg-accent-blue/10 text-accent-blue'
                  : 'border-light-border hover:border-accent-blue/50 hover:bg-light-hover'
              }`}
            >
              <Icon className="w-5 h-5" />
              <div className="text-center">
                <div className="text-sm font-medium">{mode.label}</div>
                <div className="text-[10px] opacity-60 mt-0.5 hidden sm:block">{mode.description}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
